import { IconChevronDown as TablerIconChevronDown } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconChevronDown = /*#__PURE__*/ createOutlineIcon(
  TablerIconChevronDown,
  'IconChevronDown',
);
